import { Outlet } from "react-router-dom";

const Servicios = () => {
  return (
    <div style={{ marginTop: "10px" }}>
      <Outlet />
    </div>
  );
};

export default Servicios;
